import { render, staticRenderFns } from "./IntroCard.vue?vue&type=template&id=49920a3b"
import script from "./IntroCard.vue?vue&type=script&lang=ts"
export * from "./IntroCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports